import { Details, Section, Title } from "components/shared"
import React from "react"

const FAQs = ({ id, questions }) => {
  const details = questions.map((question) => {
    return {
      title: question.question,
      description: question.answer,
    }
  })
  return (
    <Section id={id} className="bg-blue text-grey" contentClassName="space-y-8" padding="md" animate>
      <Title title="Common Questions Asked" pretitle="FAQS" size="sm" width="max" center animate />
      <Details className="max-w-[800px] mx-auto" details={details} closedByDefault />
    </Section>
  )
}

export default FAQs
